import React from 'react';
import type { CSSProperties, ReactNode } from 'react';

interface FlexProps {
  children: ReactNode;
  direction?: CSSProperties['flexDirection'];
  justify?: CSSProperties['justifyContent'];
  align?: CSSProperties['alignItems'];
  gap?: CSSProperties['gap'];
  style?: CSSProperties;
  className?: string;
  onClick?: () => void;
  id?: string
}

const Flex: React.FC<FlexProps> = ({
  id,
  children,
  direction = 'row',
  justify = 'space-between',
  align = 'center',
  gap,
  style,
  className,
  onClick,
}) => (
  <div
    className={className}
    id={id}
    onClick={onClick}
    style={{
      display: 'flex',
      flexDirection: direction,
      justifyContent: justify,
      alignItems: align,
      gap,
      ...style,
    }}
  >
    {children}
  </div>
);

export default Flex;